import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GetAddressPipe } from '@app/shared/pipes/get-address.pipe';

@Component({
  selector: 'app-gps-and-type-buildings-option',
  templateUrl: './gps-and-type-buildings-option.component.html',
  styleUrls: ['./gps-and-type-buildings-option.component.scss'],
  providers: [GetAddressPipe],
})
export class GpsAndTypeBuildingsOptionComponent {
  @Input() data: any[] | null = null;
  @Output() selectEvent = new EventEmitter<any>();

  trackByIdentity(_: number, item: any) {
    return item.marker.options.data.guid;
  }

  onSelect(item: any) {
    this.selectEvent.emit(item);
  }

  trackByFnMeter(_: number, item: any) {
    return item.guid;
  }
}
